import { Navigate } from "react-router-dom";
import { useAuth } from "@components/AuthContext";
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function ProfessorRoute({ children }) {
  const lang = useLang() 
  const { user, loading } = useAuth();

  if (loading) return null; // 로딩 중엔 아무것도 렌더 안함

  const clss = user?.clss ?? "";
  const isProfGroup =
    clss === "PROFESSOR" ||
    clss === "ASSISTANT";

  // 교수/조교가 아니면 접근 차단
  if (!isProfGroup) {
    return <Navigate to={buildLangHref("/", lang)} replace />;
  }

  return children;
}
